// Shared logic for a course's customizable appearance (banner style + colors).
// Used by the instructor's course editor (Appearance tab) and by the public
// course-detail page, so both render the exact same banner for a given theme.

export const DEFAULT_COURSE_THEME = {
  style: 'default',
  primaryColor: '#0d9488',
  backgroundColor: '#0f172a',
};

export function withThemeDefaults(theme) {
  return { ...DEFAULT_COURSE_THEME, ...(theme || {}) };
}

// Builds the CSS `background` value for a course's hero/banner given its theme.
export function courseHeroBackground(theme) {
  const t = withThemeDefaults(theme);
  switch (t.style) {
    case 'gradient':
      return `linear-gradient(135deg, ${t.backgroundColor} 0%, ${t.primaryColor} 100%)`;
    case 'minimal':
      return '#f8fafc';
    case 'bold':
      return t.primaryColor;
    default:
      return t.backgroundColor;
  }
}

// Perceived brightness (ITU-R BT.601) -- true if the color is light enough
// that dark text should sit on top of it instead of white text.
export function isLightColor(hex) {
  if (!hex) return false;
  const c = hex.replace('#', '');
  if (c.length !== 6) return false;
  const r = parseInt(c.slice(0, 2), 16);
  const g = parseInt(c.slice(2, 4), 16);
  const b = parseInt(c.slice(4, 6), 16);
  if ([r, g, b].some(Number.isNaN)) return false;
  return (r * 299 + g * 587 + b * 114) / 1000 > 180;
}

// The color banner text/badges should be checked against for contrast.
// For "gradient" this checks the background end, a reasonable proxy since
// that's usually the darker/more dominant side of the two-tone banner.
export function bannerReferenceColor(theme) {
  const t = withThemeDefaults(theme);
  switch (t.style) {
    case 'minimal':
      return '#f8fafc';
    case 'bold':
      return t.primaryColor;
    default:
      return t.backgroundColor;
  }
}
